import PipelineIntegrations from './PipelineIntegrations/PipelineIntegrations'
import PipelineName from './PipelineName/PipelineName'
import PipelineParameters from './PipelineParameters/PipelineParameters'
import PipelineRepositories from './PipelineRepositories/PipelineRepositories'
import PipelineSecrets from './PipelineSecrets/PipelineSecrets'
import PipelineSettingsFooter from './PipelineSettingsFooter/PipelineSettingsFooter'
import PipelineTriggers from './PipelineTriggers/PipelineTriggers'

export default function PipelineSettingsSidebar() {
  return (
    <>
      <PipelineName />
      <PipelineParameters />
      <PipelineSecrets />
      <PipelineTriggers />
      <PipelineRepositories />
      <PipelineIntegrations />
      <PipelineSettingsFooter />
    </>
  )
}
